import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=2bde5fce"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports